import { Position } from '../types';
import type { XYPosition } from '../types';

/** How far curves bend when the target lies behind a handle's side (v11 default). */
export const DEFAULT_CURVATURE = 0.25;

/** Scales the bend for targets behind the handle so short backward edges still loop visibly. */
const BACKWARD_BEND_FACTOR = 25;
const HALF = 0.5;

/**
 * Distance of a control point from its end point. `distance` is how far the other end lies in front of
 * this handle's side: forward → half that distance; backward → a curve that grows with its square root.
 */
const controlOffset = (distance: number, curvature: number): number =>
  distance >= 0 ? HALF * distance : curvature * BACKWARD_BEND_FACTOR * Math.sqrt(-distance);

/** Control point for the end at `from`, pushed out from the side `position` towards `to`. */
export const getControlPoint = (
  position: Position,
  from: XYPosition,
  to: XYPosition,
  curvature: number,
): XYPosition => {
  switch (position) {
    case Position.Left:
      return { x: from.x - controlOffset(from.x - to.x, curvature), y: from.y };
    case Position.Right:
      return { x: from.x + controlOffset(to.x - from.x, curvature), y: from.y };
    case Position.Top:
      return { x: from.x, y: from.y - controlOffset(from.y - to.y, curvature) };
    case Position.Bottom:
      return { x: from.x, y: from.y + controlOffset(to.y - from.y, curvature) };
  }
};
